//User actions
export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const RECEIVED_USER_INFO = 'RECEIVED_USER_INFO';
export const FETCH_USER_INFO_ERROR = 'FETCH_USER_INFO_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
